import { startPlayerInactivityWatch } from './inactivityLogout.js';

if (typeof window !== 'undefined') {
  startPlayerInactivityWatch();
}
